import { helpers} from './helpers.js';
import Vue from 'vue';
import Vuex from 'vuex';
import Vuetify from 'vuetify/lib';
Vue.use(Vuex)

export const store = new Vuex.Store({
	strict: true,
	state: {
		assignmentTypes: {
			'supplier' : 'Supplier Fields',
			'customer' : 'Customer Fields',
			'order' : 'Order Fields',
			'orderitem' : 'Product Row Fields',
			'purchase-order' : 'Purchase Order Fields',
			'purchase-orderitem' : 'Purchase Order Product Row Fields'
		},
		activemenu: null,
		activetab: 0,
		activePlan: null,
		capabilities: {},
		customers: [],
		dashboards: [],
		dataloaded: false,
		departments: [],
		exports: [],
		fieldassignments: [],
		fieldgroups: [],
		fields: [],
		// last_updates: {},
		loaded_departments: [],
		orderDialog: false,
		purchaseOrderDialog: false,
		orderRange: {
			from: null,
			to: null
		},
		orders: [],
		planfeatures: [],
		posttypes: [],
		posttype_items: [],
		purchaseOrders: [],
		pricetypes: [],
		processing: false,
		products: [],
		reports: [],
		roles: [],
		snackbar: {},
		theme: {},
		themedarks: {}
	},
	getters: {
		customerField : state => {
			return state.fields.filter(field => field.internal_name === 'customer' && field.assignment_type === 'order')[0];
		},
		dateField : state => {
			return state.fields.filter(field => field.internal_name === 'date' && field.assignment_type === 'order')[0];
		},
		orderpriceField : state => {
			return state.fields.filter(field => field.internal_name === 'order_price' && field.assignment_type === 'order')[0];
		},
		productField : state => {
			return state.fields.filter(field => field.internal_name === 'product' && field.assignment_type === 'orderitem')[0];
		},
		pricetypeField : state => {
			return state.fields.filter(field => field.internal_name === 'price_type' && field.assignment_type === 'orderitem')[0];
		},
		priceField : state => {
			return state.fields.filter(field => field.internal_name === 'price' && field.assignment_type === 'orderitem')[0];
		},
		totalField : state => {
			return state.fields.filter(field => field.internal_name === 'total' && field.assignment_type === 'orderitem')[0];
		},
		po_customerField : state => {
			return state.fields.filter(field => field.internal_name === 'customer' && field.assignment_type === 'purchase-order')[0];
		},
		po_dateField : state => {
			return state.fields.filter(field => field.internal_name === 'date' && field.assignment_type === 'purchase-order')[0];
		},
		po_orderpriceField : state => {
			return state.fields.filter(field => field.internal_name === 'order_price' && field.assignment_type === 'purchase-order')[0];
		},
		po_productField : state => {
			return state.fields.filter(field => field.internal_name === 'product' && field.assignment_type === 'purchase-orderitem')[0];
		},
		po_pricetypeField : state => {
			return state.fields.filter(field => field.internal_name === 'price_type' && field.assignment_type === 'purchase-orderitem')[0];
		},
		po_priceField : state => {
			return state.fields.filter(field => field.internal_name === 'price' && field.assignment_type === 'purchase-orderitem')[0];
		},
		po_totalField : state => {
			return state.fields.filter(field => field.internal_name === 'total' && field.assignment_type === 'purchase-orderitem')[0];
		},
		fieldIds: (state, getters) => {
			return {
				date: (getters.dateField ? getters.dateField.id : null),
				customer: (getters.customerField ? getters.customerField.id : null),
				product: (getters.productField ? getters.productField.id : null),
				order_price: (getters.orderpriceField ? getters.orderpriceField.id : null),
				price_type: (getters.pricetypeField ? getters.pricetypeField.id : null),
				price: (getters.priceField ? getters.priceField.id : null),
				total: (getters.totalField ? getters.totalField.id : null)
			}
		},
		poFieldIds:(state, getters) => {
			return {
				date: (getters.po_dateField ? getters.po_dateField.id : null),
				customer: (getters.po_customerField ? getters.po_customerField.id : null),
				product: (getters.po_productField ? getters.po_productField.id : null),
				order_price: (getters.po_orderpriceField ? getters.po_orderpriceField.id : null),
				price_type: (getters.po_pricetypeField ? getters.po_pricetypeField.id : null),
				price: (getters.po_priceField ? getters.po_priceField.id : null),
				total: (getters.po_totalField ? getters.po_totalField.id : null)
			}
		},
		fieldOptions : state => {
			let types = {},
				options = [],
				assignmentTypes = ['order', 'orderitem', 'customer'];
			for (let x = 0, field; field = state.fields[x]; x++){
				if(assignmentTypes.indexOf(field.assignment_type) > -1) {
					if(!types[field.assignment_type])
						types[field.assignment_type] = [];
					types[field.assignment_type].push(field);
				}
			};
			for(let type in types){
				if (types.hasOwnProperty(type)) {
					let header = state.assignmentTypes[type] ? state.assignmentTypes[type] : type + ' Fields';
					options.push({ header });
					types[type].forEach(field => {
						options.push(field);
					});
				}
			}
			return options;
		},
		poFieldOptions : state => {
			let types = {},
				options = [],
				assignmentTypes = ['purchase-order', 'purchase-orderitem', 'supplier'];
			for (let x = 0, field; field = state.fields[x]; x++){
				if(assignmentTypes.indexOf(field.assignment_type) > -1) {
					if(!types[field.assignment_type])
						types[field.assignment_type] = [];
					types[field.assignment_type].push(field);
				}
			};
			for(let type in types){
				if (types.hasOwnProperty(type)) {
					let header = state.assignmentTypes[type] ? state.assignmentTypes[type] : type + ' Fields';
					options.push({ header });
					types[type].forEach(field => {
						options.push(field);
					});
				}
			}
			return options;
		},
		fieldShortcodes : state => {
			let codes = {};
			for (let x = 0, field; field = state.fields[x]; x++){
				if(field.assignment_type !== 'purchase-order' && field.assignment_type !== 'purchase-orderitem') {
					codes[field.internal_name] = {
						id: field.id,
						type: field.type
					};
				}
			}
			return codes;
		},
		poFieldShortcodes : state => {
			let codes = {};
			for (let x = 0, field; field = state.fields[x]; x++){
				if(field.assignment_type !== 'order' && field.assignment_type !== 'orderitem') {
					codes[field.internal_name] = {
						id: field.id,
						type: field.type
					};
				}
			}
			return codes;
		},
		keyedCustomers: state => {
			return _.keyBy(state.customers, 'id');
		},
		keyedDepartments: state => {
			return _.keyBy(state.departments, 'id');
		},
		keyedFields: state => {
			return _.keyBy(state.fields, 'id');
		},
		keyedFieldOptions: state => {
			let options = {};
			for(let x = 0, field; field = state.fields[x]; x++){
				if((field.type === 'select' || field === 'status') && !!field.fieldoptions && field.fieldoptions.length){
					for(let y = 0, fieldoption; fieldoption = field.fieldoptions[y]; y++)
						options[fieldoption.id] = fieldoption;
				}
			};
			return options;
		},
		keyedFieldgroups: state => {
			return _.keyBy(state.fieldgroups, 'id');
		},
		keyedPosttypes: state => {
			return _.keyBy(state.posttypes, 'id');
		},
		keyedPosttypeItems: state => {
			return _.keyBy(state.posttype_items, 'id');
		},
		keyedPriceTypes: state => {
			return _.keyBy(state.pricetypes, 'id');
		},
		keyedProducts: state => {
			return _.keyBy(state.products, 'id');
		},
		// orderIndexes: state => {
		// 	let orders = {};
		// 	for (let x = 0, order; order = state.orders[x]; x++){
		// 		orders[order.id] = x;
		// 	};
		// 	return orders;
		// },
		themedarksactive: state => {
			return (state.theme && state.themedarks.light ? (state.theme.dark ? state.themedarks.dark : state.themedarks.light) : helpers.defaults.themedarks.light);
		},
		orderDepartments: state => {
			return state.departments.filter(department => department.assignment_type === 'order');
		},
		purchaseOrderDepartments: state => {
			return state.departments.filter(department => department.assignment_type === 'purchase-order');
		}
	},
	mutations: {
		add: function(state, { name, data }){
			if(name === 'orders'){
				let fieldIds = (data.assignment_type === 'purchase-order') ? this.getters.poFieldIds : this.getters.fieldIds;
				data = helpers.pushOrderValues(data, fieldIds);
			}
			state[name].push(data);
		},
		addLog: function (state, { name, index, log }) {
			state[name][index].logs.push(log);
		},
		addPrice: function(state, { type, index, price }){
			state[type][index].prices.push(price);
		},
		addBulk: function(state, { name, data }){
			state[name].push(...data);
		},
		change: function(state, { name, index, data }){
			if(name === 'orders'){
				let fieldIds = (data.assignment_type === 'purchase-order') ? this.getters.poFieldIds : this.getters.fieldIds;
				data = helpers.pushOrderValues(data, fieldIds);
			}
			Vue.set(state[name], index, data);
		},
		changeConfig: function(state, { name, index, property, data }){
			state[name][index].configuration[property] = data;
		},
		changePrice: function(state, { type, index, price_index, price }){
			Vue.set(state[type][index].prices, price_index, price);
		},
		changeItemProperty: function(state, { name, index, property, data }){
			if(Array.isArray(data)){
				state[name][index][property].splice(0, state[name][index][property].length);
				for (let x = 0, dataitem; dataitem = data[x]; x++)
					state[name][index][property].push(dataitem);
			}else{
				state[name][index][property] = data;
			}
		},
		changeItemChildProperty: function(state, { name, index, child, property, data }){
			state[name][index][child][property] = data;
		},
		changeProperty: function(state, { name, property, data }){
			state[name][property] = data;
		},
		remove: function(state, { name, index }){
			state[name].splice(index, 1);
		},
		removePrice: function(state, { type, index, price_index }){
			state[type][index].prices.splice(price_index, 1);
		},
		set: function(state, { name, value }){
			state[name] = value;
		}
	},
	actions: {
		add: function(context, { name, data }){
			data = helpers.setDefault(name, data);			
			context.commit('add', { name, data });
		},
		addOrUpdate: function(context, {name, data}){
			let index = _.findIndex(context.state[name], ['id', data.id]),
				mutation = (index > -1 ? 'change' : 'add');
			data = helpers.setDefault(name, data);
			context.commit(mutation, { name, index, data });
		},
		addOrderLog: function(context, { id, log }){
			let index = _.findIndex(context.state.orders, ['id', id]);
			if (index > -1)
				context.commit('addLog', { name: 'orders', index, log });
		},
		removePrice: function(context, { type, id, price_id }){
			let index = -1,
				price_index = -1;
			for(let x = 0, item; item = context.state[type][x]; x++){
				if (item.id == id){
					index = x;
					break;
				}
			}
			for(let y = 0, price; price = context.state[type][index].prices[y]; y++){
				if (price.id == price_id){
					price_index = y;
					break;
				}
			}
			context.commit('removePrice', { type, index, price_index });
		},
		addPrice: function(context, { type, id, price }){
			let index = -1;
			for(let x = 0, item; item = context.state[type][x]; x++){
				if(item.id == id){
					index = x;
					break;
				}
			}
			context.commit('addPrice', { type, index, price });
		},
		changePrice: function(context, { type, id, old_id, price }){
			let index = -1,
				price_index = -1;
			for (let x = 0, item; item = context.state[type][x]; x++){
				if(item.id == id){
					index = x;
					break;
				}
			}
			if(old_id == price.id){
				for (let y = 0, price; price = context.state[type][index].prices[y]; y++){
					if (price.id == price.id){
						price_index = y;
						break;
					}
				}
				context.commit('changePrice', { type, index, price_index, price });
			}else{
				for (let y = 0, price; price = context.state[type][index].prices[y]; y++){
					if (price.id == old_id){
						price_index = y;
						break;
					}
				}
				context.commit('removePrice', { type, index, price_index });
				context.commit('addPrice', { type, index, price });
			}
		},
		change: function(context, { name, data, property = false, config = false }) {
			let index = _.findIndex(context.state[name], ['id', data.id]),
				// index = _.findIndex(context.state[name], ['id', data.id]),
				mutation = (config ? 'changeConfig' : property ? 'changeItemProperty' : 'change');
			data = (property ? data.value : data);
			if(name === 'fields' && !property)
				data = helpers.setField(data);

			context.commit(mutation, { name, index, property, data });
			if(name === 'orders')
				context.commit('changeItemProperty', { name, index, property: 'load_type', data: 'local' });
		},
		changeItemProperty: function(context, { name, index, property, data }){
			context.commit('changeItemProperty', { name, index, property, data });
		},
		changeItemChildProperty: function(context, { name, index, child, property, data }){
			context.commit('changeItemChildProperty', { name, index, child, property, data });
		},
		changeProperty: function(context, { name, property, data }){
			context.commit('changeProperty', { name, property, data });
		},
		changePosition: function(context, { newposition, oldposition, assignment_type }){
			let fields = _.cloneDeep(context.state.fields),
				min = Math.min.apply(Math, [oldposition, newposition]),
				max = Math.max.apply(Math, [oldposition, newposition]);

			for (let x = 0, field; field = fields[x]; x++){
				if(field.position >= min && field.position <= max && field.assignment_type === assignment_type){
					if(field.position === oldposition){
						field.position = newposition;
					}else if(newposition > oldposition){
						field.position = (field.position - 1);
					}else{
						fields[x].position = (field.position + 1);
					}
					context.commit('change', {
						name: 'fields',
						index: x,
						data: field
					});
				}
			}
		},
		load: function(context, name){
			return new Promise((resolve, reject) => {
				axios.get('/api/'+name)
					.then(response => {
						let value = response.data[name];
						value = helpers.setDefaults(name, value);
						context.commit('set', { name, value });
						resolve();
					})
					.catch(e => {
						reject();
						//this.errors.push(e)
					});
				});
		},
		loadfields: function(context) {
			axios.get('/api/fields')
			    .then(response => {
					context.commit('set', {
						name: 'fieldgroups',
						value: response.data.fieldgroups
					});
					context.commit('set', {
						name: 'fieldassignments',
						value: response.data.fieldassignments
					});
			        let fields = helpers.setDefaults('fields', response.data.fields);
					context.commit('set', {
						name: 'fields',
						value: fields
					});
			    })
			    .catch(e => {
			        // this.errors.push(e)
			    });
		},
		loadorders: function(context, params) {
			let orderRange = this.state.orderRange,
				from = (params.range ? moment().subtract(params.range.from, 'd').format('YYYY-MM-DD') : params.from),
				to = (params.range ? moment().add(params.range.to, 'd').format('YYYY-MM-DD') : params.to);

			let parameters = {
					loadEarlier: (orderRange.from && new Date(from) >= new Date(orderRange.from) ? false : true),
					loadLater: (orderRange.to && new Date(to) <= new Date(orderRange.to) ? false : true)
				},
				settings = {
					between: { from, to },
                    options: params.options,
                    paginated: params.paginated,
                    filters: params.filters,
					assignment_type: params.assignment_type
				};
			if(params.department){
				settings.department_id = (params.department.id ? params.department.id : -1);
				settings.department_loaded = (context.state.loaded_departments.indexOf(params.department.id) > -1);
			}

			if(params.department && params.paginated){
				settings.assignment_type = params.department.assignment_type;
			}

			return new Promise((resolve, reject) => {
				if(settings.paginated || (settings.department_id && !settings.department_loaded) || parameters.loadEarlier || parameters.loadLater){
					context.dispatch('loadordersfunction', { parameters, settings }).then(response => {
						resolve({ orders: response.orders, totalOrders: response.totalOrders });
					});
				}else{
					resolve();
				};
			})
		},
		loadordersfunction: function(context, { parameters, settings }) {
			return new Promise((resolve, reject) => {
				if (context.getters.fieldIds.date) {
					resolve(context.dispatch('loadordersfunctioncall', { parameters, settings }));
				}else{
					let interval = setInterval(() => {
						if (context.getters.fieldIds.date) {
							clearInterval(interval);
							resolve(context.dispatch('loadordersfunctioncall', { parameters, settings }));
						}
					}, 500);
				}
			});
		},
		loadordersfunctioncall: function (context, { parameters, settings }){
			let orderRange = context.state.orderRange,
				params = Object.assign({
					notbetween: { from: orderRange.from, to: orderRange.to }
				}, settings);

			return new Promise((resolve, reject) => {
				axios.post('/api/orders/load', params)
					.then(response => {
						let neworders = [],
							existingorders = !settings.paginated ? _.cloneDeep(context.state.orders) : [];

						for (let x = 0, order; order = response.data.orders[x]; x++) {
							let fieldIds = (order.assignment_type === 'purchase-order') ? context.getters.poFieldIds : context.getters.fieldIds,
								departments = (order.assignment_type === 'purchase-order') ? context.getters.purchaseOrderDepartments : context.getters.orderDepartments,
								data = helpers.pushOrderValues(helpers.setOrder({ order, departments, loadType: 'initial', fieldIds }), fieldIds),
								index = _.findIndex(context.state.orders, ['id', order.id]);
                            if(settings.paginated){
                                neworders.push(data);
                            }else if(index > -1){
								Object.assign(existingorders[index], data);
							}else{
                                existingorders.push(data);
							}
						}
                        if(!settings.paginated){
                            context.commit('set', { name: 'orders', value: existingorders });
                            if (params.department_id) context.commit('add', { name: 'loaded_departments', data: params.department_id });
                            if (parameters) {
                                if (parameters.loadEarlier) context.commit('changeProperty', { name: 'orderRange', property: 'from', data: params.between.from });
                                if (parameters.loadLater) context.commit('changeProperty', { name: 'orderRange', property: 'to', data: params.between.to });
                            }
                        }
						let orders = settings.paginated ? neworders : response.data.orders;
						resolve({ orders, totalOrders: response.data.totalOrders });
					})
					.catch(e => {
						reject(e);
                        console.log(e);
					});
			});
		},
		loadSingle: function(context, { name, id }){
			return new Promise((resolve, reject) => {
				axios.get('/api/'+name+'/'+id)
					.then(response => {
						resolve(response.data);
					})
					.catch(e => {
						reject(e);
					});
			});
		},
		orderUpdated: function(context, e) {
			let index = _.findIndex(context.state.orders, ['id', parseInt(e.order_id)]);

			if(index > -1){
				let order = _.cloneDeep(context.state.orders[index]),
					departments = order.assignment_type === 'order' ? context.getters.orderDepartments : context.getters.purchaseOrderDepartments;
				order.load_type = 'ajax';
				order.load_time = moment();

				if(e.type === 'config'){
					let configObj = {};
					configObj[e.subvalue] = e.value;
					Object.assign(order.configuration, configObj);
					context.commit('change', { name: 'orders', index, data: order });
				}else if(e.type === 'order-item'){
					let orderitem = (e.value ? e.value : null),
						id = (orderitem ? orderitem.id : e.subvalue),
						setindex = _.findIndex(order.orderitems, ['id', id]);
					if(!orderitem){
						context.dispatch('loadSingle', { name: 'orderitems', id }).then(response => {
							let fieldIds = (order.assignment_type === 'purchase-orderitem') ? context.getters.poFieldIds : context.getters.fieldIds;
							orderitem = helpers.pushOrderitemValues({ orderitem, fieldIds });
							if(setindex > -1){
								Object.assign(order.orderitems[setindex], orderitem);
							}else{
								order.orderitems.push(orderitem)
							}
							context.commit('change', { name: 'orders', index, data: order });
						});
					}else{
						let fieldIds = (order.assignment_type === 'purchase-orderitem') ? context.getters.poFieldIds : context.getters.fieldIds;
						orderitem = helpers.pushOrderitemValues({ orderitem, fieldIds });
						if(setindex > -1){
							let keyedVals = {};
							for (let y = 0, fieldvalue; fieldvalue = orderitem.fieldvalues[y]; y++)
								keyedVals[fieldvalue.field_id] = fieldvalue;
							for (let y = 0, fieldvalue; fieldvalue = order.orderitems[setindex].fieldvalues[y]; y++){
								if(!keyedVals[fieldvalue.field_id])
									orderitem.fieldvalues.push(fieldvalue);
							}
							Object.assign(order.orderitems[setindex], orderitem);
						}else{
							order.orderitems.push(orderitem);
							for (let x = 0, department; department = departments[x]; x++)
								order.configuration['d' + department.id] = true;
						}
						context.commit('change', { name: 'orders', index, data: order });
					}
				}else if(e.type === 'value'){
					let set = false;
					if(order.assignment_type === 'order' || order.assignment_type === 'purchase-order'){
						for (let x = 0, fieldvalue; fieldvalue = order.fieldvalues[x]; x++){
							if(fieldvalue.field_id ===  e.value.field_id){
								fieldvalue = e.value;
								set = true
								break;
							}
						}
						if(!set)
							order.fieldvalues.push(e.value);
						if(e.subvalue)
							Object.assign(order, e.subvalue);
					}else{
						for (let y = 0, orderitem; orderitem = order.orderitems[y]; y++){
							if(orderitem.id === e.value.assignment_id){
								for (let x = 0, fieldvalue; fieldvalue = orderitem.fieldvalues[x]; x++){
									if(fieldvalue.field_id ===  e.value.field_id){
										Object.assign(fieldvalue, e.value);
										set = true
										break;
									}
								}
								if(!set)
									orderitem.fieldvalues.push(e.value);
								if(e.subvalue)
									Object.assign(orderitem, e.subvalue);
								break;
							}
						}
					}

					context.commit('change', { name: 'orders', index, data: order });
				}else if(e.type === 'delete'){
					context.commit('remove', { name: 'orders', index });
				}else if(e.type === 'update'){
					let order = (e.value ? e.value : null);

					if (!order) {
						context.dispatch('loadSingle', { name: 'orders', id: e.order_id }).then(response => {
							let fieldIds = (response.assignment_type === 'purchase-order') ? context.getters.poFieldIds : context.getters.fieldIds;
							order = helpers.setOrder({ order: response, departments, loadType: 'ajax', fieldIds });
							context.dispatch('addOrUpdate', {name: 'orders', data: order});
						});
					} else {
						let fieldIds = (order.assignment_type === 'purchase-order') ? context.getters.poFieldIds : context.getters.fieldIds;
						order = helpers.setOrder({ order, departments, loadType: 'ajax', fieldIds });
						context.dispatch('addOrUpdate', {name: 'orders', data: order});
					}
				}
			}else if(e.type !== 'delete'){
				let loadorder = false,
					order = null;

				if(e.type !== 'add' && e.type !== 'update'){
					if(e.type === 'config' && /(^d[0-9]*$)/.test(e.subvalue) && e.value === true)
						loadorder = true;
					if(e.type === 'value' && e.subvalue && e.subvalue.date){
						let date = new Date(e.subvalue.date);
						if(date >= new Date(context.state.orderRange.from) || date <= new Date(context.state.orderRange.to))
							loadorder = true;
					}
				}else{
					order = ( e.value ? e.value : null );
					loadorder = ( e.value ? false : true );
				}

				if(loadorder && !order){
					context.dispatch('loadSingle', { name: 'orders', id: e.order_id }).then(response => {
						let fieldIds = (response.assignment_type === 'purchase-order') ? context.getters.poFieldIds : context.getters.fieldIds,
							departments = response.assignment_type === 'order' ? context.getters.orderDepartments : context.getters.purchaseOrderDepartments;
						order = helpers.setOrder({ order: response, departments, loadType: 'ajax', fieldIds });
						context.dispatch('addOrUpdate', {name: 'orders', data: order});
					});
				}else if(order){
					let fieldIds = (order.assignment_type === 'purchase-order') ? context.getters.poFieldIds : context.getters.fieldIds,
						departments = order.assignment_type === 'order' ? context.getters.orderDepartments : context.getters.purchaseOrderDepartments;
					order = helpers.setOrder({ order, departments, loadType: 'ajax', fieldIds });
					context.dispatch('addOrUpdate', {name: 'orders', data: order});
				}
			}

			if (e.log) {
				context.dispatch('addOrderLog', { id: e.order_id, log: e.log });
			}
		},
		remove: function(context, { name, data }){
			let item = context.state[name].filter(item => {
					if(item.id === data.id)
						return true;
					return false;
				})[0],
				index = context.state[name].indexOf(item);
			context.commit('remove', { name, index });
		},
		set: function(context, { name, value }){
			context.commit('set', { name, value });
		},
		setActiveplan: function (context) {
			return new Promise((resolve, reject) => {
				axios.get('/api/activeplan').then(response => {
					context.commit('set', { name: 'activePlan', value: response.data });
					resolve();
				});
			});
		},
		setCapabilities: function(context, { user, teams, team_id = user.current_team_id }){
			return new Promise((resolve, reject) => {
				let team = teams.filter(team => {
						return team.id == team_id ? true : false;
					})[0],
					pivot = team.pivot;
				if (pivot.systemrole_id){
					axios.get('/api/role/' + pivot.systemrole_id+'/capabilities')
					    .then(response => {
							let capabilities = _.cloneDeep(response.data.capabilities);
							capabilities = helpers.setCapabilities(capabilities);
							if (pivot.capabilities){
								for(let group in capabilities){
									if(pivot.capabilities[group])
										capabilities[group] = Object.assign(capabilities[group], pivot.capabilities[group]);
								}
							}
							context.commit('changeProperty', {
								name: 'capabilities',
								property: team_id,
								data: capabilities
							});
							resolve();
					    })
					    .catch(e => {
					    	reject(e);
					    });
				}else{
					let capabilities = _.cloneDeep(helpers.defaults.capabilities);

					if(team.owner_id === user.id){
						for(let group in capabilities){
							for(let capability in capabilities[group])
								capabilities[group][capability] = true;
						}
					}					
					context.commit('changeProperty', {
						name: 'capabilities',
						property: team_id,
						data: capabilities
					});
					resolve();
				}
			});
		},
        setSnack(context, { state, text }){
			context.commit('set', {
				name: 'snackbar',
				value: { state, text }
			});
		}
	}
});
